import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class RasGtmService {
    constructor() {
        this.gtmId = "GTM-NRC6WMJ";
        this.gtmIdSeguros = "GTM-PZ2PXB";
        this.browserGlobals = {
            /**
             * @return {?}
             */
            windowRef() {
                return window;
            },
            /**
             * @return {?}
             */
            documentRef() {
                return document;
            }
        };
        this.pushOnDataLayer = (/**
         * @param {?} obj
         * @return {?}
         */
        (obj) => {
            return new Observable((/**
             * @param {?} observer
             * @return {?}
             */
            (observer) => {
                try {
                    /** @type {?} */
                    const dataLayer = this.getDataLayer();
                    dataLayer.push(obj);
                    observer.next(true);
                    observer.complete();
                }
                catch (_a) {
                    observer.next(false);
                    observer.error();
                }
            }));
        });
        this.addGtmToDom = (/**
         * @return {?}
         */
        () => {
            return new Observable((/**
             * @param {?} observer
             * @return {?}
             */
            (observer) => {
                try {
                    this.pushOnDataLayer({
                        'gtm.start': new Date().getTime(),
                        event: 'gtm.js'
                    }).subscribe({
                        next: (/**
                         * @return {?}
                         */
                        () => {
                            this.addGtmToDomProcess();
                            observer.next(true);
                            observer.complete();
                        })
                    });
                }
                catch (_a) {
                    observer.next(false);
                    observer.error();
                }
            }));
        });
    }
    /**
     * @private
     * @return {?}
     */
    getDataLayer() {
        /** @type {?} */
        const window = this.browserGlobals.windowRef();
        window['dataLayer'] = window['dataLayer'] || [];
        return window['dataLayer'];
    }
    /**
     * @private
     * @return {?}
     */
    addGtmToDomProcess() {
        /** @type {?} */
        const doc = this.browserGlobals.documentRef();
        /** @type {?} */
        const hostname = window.location.hostname;
        /** @type {?} */
        const rootDomain = this.getRootDomain(hostname);
        /** @type {?} */
        const gtmHost = `www.${rootDomain}`;
        /** @type {?} */
        const gtmid = (hostname.includes('seguros.es') || hostname.includes('segurostest.es'))
            ? this.gtmIdSeguros
            : this.gtmId;
        /** @type {?} */
        const gtmScript = doc.createElement('script');
        gtmScript.id = 'GTMscript';
        gtmScript.async = true;
        gtmScript.src = `//${gtmHost}/tm/gtm.js?id=${gtmid}`;
        doc.head.insertBefore(gtmScript, doc.head.firstChild);
        /** @type {?} */
        const ifrm = doc.createElement('iframe');
        ifrm.setAttribute('src', `//${gtmHost}/tm/ns.html?id=${gtmid}`);
        ifrm.style.width = '0';
        ifrm.style.height = '0';
        ifrm.style.display = 'none';
        ifrm.style.visibility = 'hidden';
        /** @type {?} */
        const noscript = doc.createElement('noscript');
        noscript.id = 'GTMiframe';
        noscript.appendChild(ifrm);
        doc.body.insertBefore(noscript, doc.body.firstChild);
    }
    /**
     * @private
     * @param {?} hostname
     * @return {?}
     */
    getRootDomain(hostname) {
        /** @type {?} */
        const parts = hostname.split('.');
        if (parts.length >= 2) {
            return parts.slice(-2).join('.');
        }
        return hostname;
    }
}
RasGtmService.ɵfac = function RasGtmService_Factory(t) { return new (t || RasGtmService)(); };
RasGtmService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RasGtmService, factory: RasGtmService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RasGtmService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    RasGtmService.prototype.gtmId;
    /**
     * @type {?}
     * @private
     */
    RasGtmService.prototype.gtmIdSeguros;
    /**
     * @type {?}
     * @private
     */
    RasGtmService.prototype.browserGlobals;
    /** @type {?} */
    RasGtmService.prototype.pushOnDataLayer;
    /** @type {?} */
    RasGtmService.prototype.addGtmToDom;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RasGtmModule {
}
RasGtmModule.ɵfac = function RasGtmModule_Factory(t) { return new (t || RasGtmModule)(); };
RasGtmModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RasGtmModule });
RasGtmModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RasGtmModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                exports: []
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { RasGtmModule, RasGtmService };

